/**
 * @file notice-risk-labels.ts
 * @description Подписи кнопок окна о риске режима «Уведомление» (phase19.16,
 * Р3г; SB133). Одна константа на окно владельца (`NoticeRiskDialog`) и его
 * образец в кабинете платформы (`NoticeRiskPreview`): тексты кнопок не
 * входят в редакцию платформы и не должны разойтись (ревью М5).
 */

export const NOTICE_RISK_BUTTON_LABELS = Object.freeze({
  /** Отказ: режим не меняется. */
  keepConsent: "Оставить «Только после согласия»",
  /** Галочка стоит — включить режим. */
  enableNotice: "Включить «Уведомление»",
});
